/* eslint-disable-next-line */
export interface ModulesCheckoutComponentsProps {}

export function ModulesCheckoutComponents(props: ModulesCheckoutComponentsProps) {
  return (
    <div>
      <h1>Welcome to ModulesCheckoutComponents!</h1>
    </div>
  );
}

export default ModulesCheckoutComponents;
